import { render, staticRenderFns } from "./ColorInfot.vue?vue&type=template&id=26a38836&scoped=true&"
import script from "./ColorInfot.vue?vue&type=script&lang=js&"
export * from "./ColorInfot.vue?vue&type=script&lang=js&"
import style0 from "./ColorInfot.vue?vue&type=style&index=0&id=26a38836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a38836",
  null
  
)

export default component.exports